import { type TFunction } from "i18next"

import { formatUsPhone } from "../../../components/PhoneInputs/PhoneInput.tsx"
import { type SmsRefusal } from "./sms-verification.services.ts"

export const SMS_REFUSAL_CODES = [
  "invalid_number",
  "number_in_use",
  "number_stopped",
  "resend_too_soon",
  "daily_limit",
  "sms_unavailable",
  "sms_busy",
  "send_failed",
  "number_changed",
  "code_expired",
  "code_for_other_target",
  "wrong_code",
  "too_many_attempts"
] as const

type SmsRefusalCode = (typeof SMS_REFUSAL_CODES)[number]

const isKnown = (code: string | undefined): code is SmsRefusalCode =>
  SMS_REFUSAL_CODES.includes(code as SmsRefusalCode)

/** The refusal in the reader's language; a code this app does not know yet
 *  falls back to the server's own sentence. */
export function smsRefusalText(
  t: TFunction,
  refusal: SmsRefusal,
  startNumber?: string | null
): string {
  const { code } = refusal
  if (code === "number_stopped" && !startNumber) {
    return refusal.message ?? t("smsVerification.refusals.number_stopped_plain")
  }
  if (isKnown(code)) {
    return t(`smsVerification.refusals.${code}`, {
      seconds: refusal.retry_after,
      count: refusal.attempts_left,
      number: formatUsPhone(startNumber)
    })
  }
  return refusal.message ?? t("smsVerification.refusals.unknown")
}
